import { app } from "@eg_ui/src/app/client";

import "@eg_ui/src/scss/client/basePage.scss";

app.mount("#app-container");
